/**
 * Extra class both shell layouts put on the lib's AppShell, so CSS can tell
 * a page inside the shell from one without it (login, public registration,
 * the printed start list). EnvironmentBanner.module.css hides the banner
 * with `body:has(.cmf-shell)`: inside the shell the top bar carries it.
 * Keep the string in step with that file.
 */
export const SHELL_CLASS = "cmf-shell";
